import {useEffect, useState} from 'react';
import {
    DndContext, 
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from '@dnd-kit/core';

import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';

import {SortableToDo} from './SortableToDo';

export function SortableToDos(props) {
    const [items, setItems] = useState([]);
    const [controller, setController] = useState([]);

    const sensors = useSensors(
            useSensor(PointerSensor),
            useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    useEffect(() => {
        if ( props.data ) {
            setItems(props.data);
        }

        if ( props.controller ) {
            setController(props.controller);
        }
    }, [props]);

    const renderToDo = (index=0) => {
        const todo = items[index];
        const animate = todo.animate ? todo.animate : false
        const id = todo.getId();

        return (
            <SortableToDo
                key={id}
                id={id}
                data={todo}
                parentController={controller}
                deleteAction={props.deleteAction}
                animate={animate}
                handle
            />
        );
    }

    const handleDragEnd = (event) => {
        const {active, over} = event;    
    
        if (active.id !== over.id) {

            const swapElements = (items) => {
                const oldIndex = items.findIndex(item => item.id === active.id);
                const newIndex = items.findIndex(item => item.id === over.id);

                return arrayMove(items, oldIndex, newIndex);
            }

            const newItems = swapElements(items);
            setItems(newItems)

            const orderList = newItems.map(obj => obj.id);
            
            updateToDosOrder(orderList);
        }
    }

    const updateToDosOrder = (boardIds=[]) => {
        controller.updateToDosOrder(boardIds);
    }

    return (
        <DndContext 
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
        >
            <SortableContext 
                items={items}
                strategy={verticalListSortingStrategy}
            >
                {items.map((id, index) => renderToDo(index))}
            </SortableContext>
        </DndContext>
    )
}